// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actions_actionsColumn__MBNdh .menu-icon svg {
  scale: 0.9;
}
`, "",{"version":3,"sources":["webpack://./src/components/wttp/questionnnaires/list/table/columns/actions/index.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ","sourcesContent":[".actionsColumn :global .menu-icon svg {\n  scale: 0.9;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionsColumn": `actions_actionsColumn__MBNdh`
};
export default ___CSS_LOADER_EXPORT___;
